import _ from "underscore"
import axios from "axios"

const calculateEndpoint = function () {
  let endpoint = "https://api.coptest.es"
  if (window.location.hostname == "localhost") {
    endpoint = "https://api.cop.local"
  }
  if (/app-cop\.blackgecko\.eu/.test(window.location.hostname)) {
    endpoint = "https://api-cop.blackgecko.eu"
  }
  console.log(`Using endpoint: ${endpoint}`)
  return endpoint
}
const endpoint = calculateEndpoint()

export default {
  getEndpoint: function () {
    return endpoint
  },
  login: async function (email, password) {
    return axios.post(endpoint + "/v1/core/login/", { email, password })
  },
  register: async function (email, password) {
    return axios.post(endpoint + "/v1/core/register/", { email, password })
  },
  createSubscription: async function (token, family) {
    return axios.post(endpoint + "/v1/core/create-subscription/", { token, family })
  },
  createPromotion: async function (token, uuid, addressData) {
    return axios.post(endpoint + "/v1/core/create-promotion/", _.extend(addressData, { token, uuid }))
  },
  requestRecover: async function(email) {
    return axios.post(endpoint + "/v1/core/request-recover/", { email })
  },
  recoverPassword: async function(password, recover_token) {
    return axios.post(endpoint + "/v1/core/recover-password/", { password, recover_token })
  },
  storeStats: async function (
    token,
    subfamily,
    stats_questions,
    stats_questions_ok,
    stats_questions_wrong,
    stats_questions_empty,
    stats_minutes
  ) {
    return axios.post(endpoint + "/v1/core/store-stats/", {
      token,
      subfamily,
      stats_questions,
      stats_questions_ok,
      stats_questions_wrong,
      stats_questions_empty,
      stats_minutes,
    })
  },
  tree: async function (token) {
    return axios.post(endpoint + "/v1/core/tree/", {token})
  },
  purchases: async function (token) {
    return axios.post(endpoint + "/v1/core/purchases/", {token})
  },
  treeFiltered: async function (token, family) {
    return axios.post(endpoint + "/v1/core/tree/", {
      token,
      family,
      attachments: 1,
    })
  },
  ranking: async function () {
    return axios.post(endpoint + "/v1/core/ranking/")
  },
  promotion: async function (uuid) {
    return axios.post(endpoint + "/v1/core/promotion/", {uuid})
  },
  subfamily: async function (subfamily) {
    return axios.post(endpoint + "/v1/core/subfamily/", { subfamily })
  },
  me: async function (token) {
    return axios.post(endpoint + "/v1/core/me/", { token })
  },
  wrongQuestions: async function (token) {
    return axios.post(endpoint + "/v1/core/worst-questions/", { token })
  },
  home: async function () {
    return axios.get(endpoint + `/v1/core/home/`)
  },
  aboutus: async function () {
    return axios.get(endpoint + `/v1/core/aboutus/`)
  },
  entries: async function () {
    return axios.get(endpoint + `/v1/core/entries/`)
  },
  entry: async function (slug) {
    return axios.get(endpoint + `/v1/core/entries/?slug=${slug}`)
  },
  service: async function (pk) {
    return axios.get(endpoint + `/v1/core/service/?pk=${pk}`)
  },
  services: async function () {
    return axios.get(endpoint + `/v1/core/services/`)
  },
  testimonials: async function () {
    return axios.get(endpoint + `/v1/core/testimonials/`)
  },
  book: async function () {
    return axios.get(endpoint + `/v1/core/book/`)
  },
  faqs: async function () {
    return axios.get(endpoint + `/v1/core/faqs/`)
  },
  report: async function (question, report, token) {
    return axios.post(endpoint + "/v1/core/report/", { question, report, token })
  },
  infoTest: async function (token, subfamily) {
    return axios.post(endpoint + "/v1/core/info-test/", { token, subfamily })
  },
  updateCustomer: async function (token, first_name, last_name, dni, alias) {
    return axios.post(endpoint + "/v1/core/customer-update/", { token, first_name, last_name, dni, alias })
  },
  newTest: async function (token, subfamily, qty) {
    return axios.post(endpoint + "/v1/core/new-test/", {
      token,
      subfamily,
      qty,
    })
  },
  getTest: async function (token, public_key) {
    return axios.post(endpoint + "/v1/core/get-test/", { token, public_key })
  },
  solveTest: async function (token, public_key, solution) {
    return axios.post(endpoint + "/v1/core/solve-test/", {
      token,
      public_key,
      solution,
    })
  },
}
